const styles = {
  box: {
    flexGrow: 0,
  },
  iconButton: {
    padding: 0,
  },
  menu: {
    marginTop: '45px',
  },
  user: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  typo: {
    marginLeft: '5px',
    maxWidth: '250px',
    cursor: 'pointer',
  },
};

export default styles;
